import { Component } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';
import { UtilisateurService } from 'src/services/utilisateur.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'app-conversion-comptes-fictifs',
    templateUrl: './conversion-comptes-fictifs.component.html',
    styleUrls: ['./conversion-comptes-fictifs.component.scss'],
    imports: [
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatChipsModule,
    MatIconModule,
    MatProgressSpinnerModule,
    TranslateModule
]
})
export class ConversionComptesFictifsComponent {
  emailInput: string = '';
  motDePasse: string = '';
  isLoading: boolean = false;

  constructor(
    private utilisateurService: UtilisateurService,
    private snackBar: MatSnackBar
  ) { }

  get emails(): string[] {
    return this.emailInput
      .split('\n')
      .map(e => e.trim())
      .filter(e => e && this.isValidEmail(e));
  }

  isValidEmail(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  convertir(): void {
    if (this.emails.length === 0) {
      this.snackBar.open('Veuillez ajouter au moins un email', 'Fermer', { duration: 3000 });
      return;
    }

    if (!this.motDePasse || this.motDePasse.length < 8) {
      this.snackBar.open('Le mot de passe doit contenir au moins 8 caractères', 'Fermer', { duration: 3000 });
      return;
    }

    this.isLoading = true;

    this.utilisateurService.ConvertirComptesEnComptesFictifsAdmin(this.emails, this.motDePasse).subscribe({
      next: () => {
        this.snackBar.open('Comptes convertis avec succès', 'Fermer', { duration: 5000 });
        this.emailInput = '';
        this.motDePasse = '';
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Erreur lors de la conversion:', error);
        this.snackBar.open(
          error.error?.message || 'Erreur lors de la conversion des comptes',
          'Fermer',
          { duration: 5000 }
        );
        this.isLoading = false;
      }
    });
  }
}
